import {isMobile} from '@/prototypes/u/other'

export default {
  path: 'characters',
  component: () => import('../../views/admin/characters/index.vue'),
  children: [
    {
      path: '',
      name: 'characters',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileCharacters" */ '@/mobile/views/admin/characters/list/charactersList.vue') : import(/* webpackChunkName: "desktopCharacters" */ '@/desktop/views/admin/characters/list/charactersList.vue') },
      meta: {
        permission: 'user_group.show',
        pageTitle: 'گروه مشتریان',
        pageTitleI18n: 'pages.users.characters.list.title'
        // rule: 'editor'
      }
    },
    {
      path: 'trash',
      name: 'charactersTrash',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileCharactersTrash" */ '@/mobile/views/admin/characters/trash/charactersTrash.vue') : import(/* webpackChunkName: "desktopCharactersTrash" */ '@/desktop/views/admin/characters/trash/charactersTrash.vue') },
      meta: {
        permission: 'user_group.delete',
        pageTitle: 'سطل زباله گروه مشتریان',
        pageTitleI18n: 'pages.users.characters.trash.title'
        // rule: 'editor'
      }
    },
    {
      path: 'insert',
      name: 'insertCharacter',
      component: () => import('../../views/admin/characters/insert/insertCharacter.vue'),
      meta: {
        permission: 'user_group.create',
        pageTitle: 'افزودن گروه مشتری',
        pageTitleI18n: 'pages.users.characters.insert.title'
        // rule: 'editor'
      }
    },
    {
      path: ':id',
      component: () => { return isMobile() ?  import('@/mobile/views/admin/characters/profile/index.vue') : import('@/desktop/views/admin/characters/profile/index.vue') },
      meta: {
        redirectNotFound: true
      },
      children: [
        {
          path: '',

          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileCharacter" */ '@/mobile/views/admin/characters/profile/characterProfile.vue') : import(/* webpackChunkName: "desktopCharacter" */ '@/desktop/views/admin/characters/profile/characterProfile.vue') },
          name: 'character',
          meta: {
            permission: 'user_group.show',
            pageTitle: 'گروه شخص',
            pageTitleI18n: 'pages.users.characters.profile.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'edit',
          name: 'editCharacter',
          component: () => import(/* webpackChunkName: "editCharacter" */ '../../views/admin/characters/edit/editCharacter.vue'),
          meta: {
            permission: 'user_group.update',
            pageTitle: 'ویرایش گروه شخص',
            pageTitleI18n: 'pages.users.characters.edit.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        },
        {
          path: 'users',
          name: 'characterUsersList',
          component: () => import(/* webpackChunkName: "characterUsersList" */ '../../views/admin/characters/users/list/characterUserList.vue'),
          meta: {
            permission: 'user_group.assign_to_user',
            pageTitle: ',افزودن شخص به گروه شخص',
            pageTitleI18n: 'pages.users.characters.user.title',
            layoutStatus: 'profile'
            // rule: 'editor'
          }
        }
      ]
    }
  ]
}
